module.exports = __webpack_public_path__ + "static/media/ringstone.8456697d.jpg";